routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider) {
    $stateProvider
        .state('home.bySearch', {
            url: "compra-rapida/carga-rapida-por-busqueda",
            template: `<by-search sh-ctrl="shCtrl"></by-search>`
        });
}

export default routesConfig;


/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/fast-purchase/by-search/by-search.config.js
 **/